@if (state$ | async; as state) {
  @if (state.loading) {
    <div class="active-session-count active-session-count--loading">
      <span>読み込み中...</span>
    </div>
  }
  @if (!state.loading && !state.error) {
    <div class="active-session-count" role="status" aria-live="polite">
      <span class="active-session-count__label"
        >現在のロールプレイ利用者数:</span
      >
      <span class="active-session-count__value">{{ state.count }}人</span>
    </div>
  }
}
